import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form } from 'react-bootstrap';
import debounce from 'lodash.debounce';
export default function TextFilter(_ref) {
  let {
    initialValue = '',
    onFilter,
    ...props
  } = _ref;
  // in case what we pass is null or undefined
  const [value, setValue] = useState(initialValue || '');
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  const debouncedOnFilter = useMemo(() => {
    return debounce(value => onFilter(value), 500);
  }, [onFilter]);
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(Form.Control, {
    value: value || '',
    onChange: e => {
      setValue(e.target.value);
      debouncedOnFilter(e.target.value);
    },
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
    },
    placeholder: "Filter"
  }));
}